import React, { useRef } from 'react';
import TickGreen from '../../../Assets/Modals/TickGreen.svg';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../../Components/Toaster/Toaster';
import { useOutsideClickHandler } from '../../../Hooks/useOutsideClick';
import { closeModal, fetchSizeCharts } from '../../../Features/inventoryManagementSlice';
import { deleteSizeChart } from '../../../lib/utils/apiCalls';

function DeleteModal() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const selectedSizeChart = useSelector((state) => state.inventoryManagement.selectedSizeChart);

    const handleCancelClick = () => {
        dispatch(closeModal());
    }

    async function handleDeleteClick() {
        try {
            const response = await deleteSizeChart(selectedSizeChart.id);
            if(response.status === 200) {
                showToast('Size chart deleted.', 'success');
                dispatch(fetchSizeCharts());
                dispatch(closeModal());
            }
        }
        catch(err) {
            showToast(err, 'error');
        }
    };

    return (
        <div ref={wrapperRef} className="w-[44%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Remove Size Chart - {selectedSizeChart.chartName} &#40;{selectedSizeChart.chartType === 'Trousers, Phants, Jeans' ? 'Trousers, Pants, Jeans' : selectedSizeChart.chartType}&#41;</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Are you sure you want to Remove Size Chart - {selectedSizeChart.chartName} &#40;{selectedSizeChart.chartType === 'Trousers, Phants, Jeans' ? 'Trousers, Pants, Jeans' : selectedSizeChart.chartType}&#41;?</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleDeleteClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-[#DC2626] shadow-[0px_1px_2px_0px_#0000000D]'>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteModal;
// shadow-[0px_0px_6px_0px_#0000001F]